import { React, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import dynamic from 'next/dynamic'
import Header from '../../components/header'
import Searching from '../../components/searching';
import Container from '../../components/taxonomies/grid/container'

const ListContainer = dynamic(() => import('../../components/taxonomies/list/listcontainer'))
const AlphaList = dynamic(() => import('../../components/taxonomies/alphafilter/alphalist'))
const Noresults = dynamic(() => import('../../components/noresults'))
const MiniCart = dynamic(() => import('../../components/cart/minicart'))
const Footer = dynamic(() => import('../../components/footer'))

import store from '../../redux/store'
import { removeUser } from '../../redux/user.slice';
import { clearShipping } from '../../redux/shipping.slice';
import { clearAddresses } from '../../redux/address.slice';

import * as ga from '../../lib/ga'
import { useSelector } from 'react-redux';

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function Category() {

  const router = useRouter();

  const cart = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const grid_view = useSelector((state) => state.grid_view.grid_view);

  const [stored_list, set_stored_list] = useState(false);
  const [stored_filters_list, set_stored_filters_list] = useState(false);
  const [stored_brand_list, set_stored_brand_list] = useState(false);
  const [price, set_price] = useState(false);
  const [menu, set_menu] = useState(false)
  const [config, set_config] = useState(false)

  const [loading, set_loading] = useState(false);
  const [searching, set_searching] = useState(true);
  const [error, set_error] = useState(false);

  const item = {
    query: (router.query.search) ? router.query.search : 'search',
    name: (router.query.search) ? "Search Results for: " + router.query.search[0].toUpperCase() + router.query.search.slice(1) : 'Search Results',
    type: 'search',
  }

  useEffect(() => {

    var token = false
    var merchant = false
    if (user[0] != undefined) {
      token = user[0].token
      if (user[0].roles != undefined && user[0].roles.findIndex((element) => element.name == "merchant") >= 0) {
        merchant = true
      }
    }

    const search_api_call = async (merchant) => {
      set_loading(true)
      set_searching(true)
      // dont render on server for blank things
      if (!router.isReady) return;
      const page = router.query.page
      const sort = router.query.sort
      const search = router.query.search
      const price_from = router.query.price_from ? router.query.price_from : null
      const price_to = router.query.price_to ? router.query.price_to : null


      // fetch serverside while rendering
      fetch(
        process.env.NEXT_PUBLIC_API_URL + '/configs',
      ).then(response => {
        // reject not ok response
        if (!response.ok) {
          return Promise.reject(response)
        }
        return response.json() // or return response.text()
      })
        .catch(async response => {
          const error = await response.json().then(text => text)
          return Promise.reject(error)
        })
        .then(data => {
          set_config(data.data)
        })
        .catch((error) => {
          console.warn(error);
        });


      fetch(
        process.env.NEXT_PUBLIC_API_URL + '/menu',
      ).then(response => {
        // reject not ok response
        if (!response.ok) {
          return Promise.reject(response)
        }
        return response.json() // or return response.text()
      })
        .catch(async response => {
          const error = await response.json().then(text => text)
          return Promise.reject(error)
        })
        .then(data => {
          set_menu(data)
        })
        .catch((error) => {
          console.warn(error);
        });


      if (merchant) {
        var endpoint = '/search-pricing'
        var headers = {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + token
        }
      } else {
        var endpoint = '/search'
        var headers = {
          'Content-Type': 'application/json',
        }
      }

      if (router.query.filters) {
        const filters = JSON.parse(router.query.filters)
        var body = {
          search: search,
          filters: filters,
          device_name: 'browser',
          page: page,
          sort: sort,
          price_from: price_from,
          price_to: price_to
        }
      } else {
        var body = {
          search: search,
          device_name: 'browser',
          page: page,
          sort: sort,
          price_from: price_from,
          price_to: price_to
        }
      }

      // fetch(
      //   process.env.NEXT_PUBLIC_API_URL + '/search-filters/filter',
      //   {
      //     body: JSON.stringify(body),
      //     headers: headers,
      //     method: 'POST'
      //   }
      // )
      //   .then(response => {
      //     // reject not ok response
      //     if (!response.ok) {
      //       return Promise.reject(response)
      //     }
      //     return response.json() // or return response.text()
      //   })
      //   .catch(async response => {
      //     const error = await response.json().then(text => text)
      //     return Promise.reject(error)
      //   })
      //   .then(data => {
      //     set_stored_filters_list(data.data)
      //   })
      //   .catch((error) => {
      //     console.warn(error);
      //   });

      // fetch(
      //   process.env.NEXT_PUBLIC_API_URL + '/search-filters/brand',
      //   {
      //     body: JSON.stringify(body),
      //     headers: headers,
      //     method: 'POST'
      //   }
      // )
      //   .then(response => {
      //     // reject not ok response
      //     if (!response.ok) {
      //       return Promise.reject(response)
      //     }
      //     return response.json() // or return response.text()
      //   })
      //   .catch(async response => {
      //     const error = await response.json().then(text => text)
      //     return Promise.reject(error)
      //   })
      //   .then(data => {
      //     set_stored_brand_list(data.data)
      //   })
      //   .catch((error) => {
      //     console.warn(error);
      //   });

      fetch(
        process.env.NEXT_PUBLIC_API_URL + endpoint,
        {
          body: JSON.stringify(body),
          headers: headers,
          method: 'POST'
        }
      )
        .then(response => {
          // reject not ok response
          if (!response.ok) {
            return Promise.reject(response)
          }
          return response.json() // or return response.text()
        })
        .catch(async response => {
          if (!response.ok && response.redirected) {
            set_error('You have logged in on another device, please login again to see pricing')
          }
          const error = await response.json().then(text => text)
          return Promise.reject(error)
        })
        .then(data => {
          set_stored_list(data.data)
          set_stored_filters_list(data.filters)
          set_stored_brand_list(data.brands)
          set_price(data.price)
          set_loading(false)
          set_searching(false)
        })
        .catch((error) => {
          console.warn(error);
        });

      // in here, tag on analytics
      ga.search(search)

    };

    const api_call_basket_validate = async () => {
      if (token) {
          var endpoint = '/validate_cart'
          var headers = {
              'Content-Type': 'application/json',
              'Authorization': "Bearer " + token
          }
          
        fetch(
          process.env.NEXT_PUBLIC_API_URL + endpoint,
          {
              body: JSON.stringify({
                  cart: cart
              }),
              headers: headers,
              method: 'POST'
          }
          ) .then(response => {
            // reject not ok response
            if (!response.ok) {
              return Promise.reject(response)
            }
            return response.json() // or return response.text()
          })
          .catch(async response => {
            if (!response.ok && response.redirected) {
              set_error('You have logged in on another device, please login again to continue!')
            }
            const error = await response.json().then(text => text)
            return Promise.reject(error)
          })
          .then(data => {
            set_error(false)
            // herre I need to overwrite the product that we are using with the new data
          })
          .catch((error) => {
            console.warn(error);
          });
      } 
    }

    search_api_call(merchant);

    if(!merchant){
      api_call_basket_validate()
    }
  }, [router, user]);


  const logout_and_redirect_to_login = () => {
    store.dispatch(clearShipping())
    store.dispatch(clearAddresses())
    store.dispatch(removeUser())
    router.push('/login', undefined, { shallow: true })
  }

  return (
    <>
      <Head>
        <title>Search</title>
        <meta name="robots" content="noindex" />
      </Head>
      <div className="wrapper h-full flex flex-col">
        <Header menu={menu} config={config}></Header>
        {(error) ? (
          <Popup open={true} closeOnDocumentClick={false} closeOnEscape={false} position="right center">
            <div className="bg-white border border-2 p-10 flex flex-col items-center">
              {error}
              <span onClick={() => logout_and_redirect_to_login()} className="mt-5 btn btn-primary p-3 w-40">Login</span>
            </div>
          </Popup>
        ) : ('')}
        {
          (searching) ? (<Searching></Searching>) : (
      
            (stored_list && stored_list.data) ? (
              // if grid_view, show one, else show other
              (grid_view) ? (
                <Container item={item} list={stored_list} name={item.name} filter_list={stored_filters_list} brand_list={stored_brand_list} loading={loading} price={price}></Container>
              ) : (
                <ListContainer item={item} list={stored_list} name={item.name} filter_list={stored_filters_list} brand_list={stored_brand_list} loading={loading} price={price}></ListContainer>
              )

            ) : (
              // in here I need a condition to see if we have children
              (item && item.children && item.children.length > 0) ? (
                <AlphaList list={item.children} type={item.type} title={item.type}></AlphaList>
              ) : (
                <Noresults></Noresults>
              )
            )
          )

        }
        {(item && item.description) ? (parse(item.description)) : ('')}
        <Footer menu={menu} config={config}></Footer>
      </div>
      <MiniCart></MiniCart>
    </>
  )
}

export default Category